import { Outlet } from "react-router-dom";
import { isFieldRole } from "@dker/core";
import { Sidebar } from "@/components/layout/Sidebar";
import { ReplyEmailNotice } from "@/components/layout/ReplyEmailNotice";
import { DemoBanner } from "@/components/layout/DemoBanner";
import { TerminationBanner } from "@/components/layout/TerminationBanner";
import { CreateFab } from "@/components/layout/CreateFab";
import { CreatePalette } from "@/components/layout/CreatePalette";
import { AgentPanel } from "@/components/agent/AgentPanel";
import { useAgentShortcut } from "@/hooks/useAgentShortcut";
import { useApplyBranding } from "@/hooks/useTenantConfig";
import { useAuthStore } from "@/stores/authStore";

export function MainLayout() {
  // Un seul point d'application pour toute l'interface authentifiée : la
  // couleur du tenant est posée sur les variables CSS, dont Tailwind dérive
  // `bg-accent`, `bg-accent/15` et le texte lisible par-dessus.
  useApplyBranding();

  // La palette et son bouton ne servent qu'au bureau : un compte de terrain ne
  // crée ni devis, ni client, ni dépense — la base le lui refuserait, et un
  // bouton qui mène à un refus est pire qu'un bouton absent.
  const role = useAuthStore((s) => s.user?.role);
  const estTerrain = isFieldRole(role);
  const estPatron = role === "patron";
  useAgentShortcut(estPatron);

  return (
    <div className="min-h-screen bg-bg-primary">
      <Sidebar />
      <main className="lg:ml-[260px]">
        <DemoBanner />
        <TerminationBanner />
        <ReplyEmailNotice />
        <Outlet />
      </main>
      {!estTerrain && (
        <>
          <CreatePalette />
          <CreateFab />
        </>
      )}
      {estPatron && <AgentPanel />}
    </div>
  );
}
